import React, { useLayoutEffect } from "react";
import Section from "../section";
import Container from "../container";
import { Link } from "react-router-dom";

function InnerBannerSection(props) {
  const data = props.content;
  return (
    <>
      {data && (
        <Section className="bg-gray-light">
          <Container>
            <div className="mx-auto max-w-screen-xl text-center h-[50vh] flex items-center flex-col justify-center ">
              {data.validate != 'false' ? (
                    <div
                      className="inline-flex items-center py-1 px-1 pr-4 mb-7 text-sm text-gray-700 bg-gray-100 rounded-full  hover:bg-gray-200"
                      role="alert"
                    >
                      <span className="text-sm font-medium">{data.SubTitle}</span>
                      <svg
                        className="ml-2 w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </div>
                
              ):(
                <div></div>
              )}
            
              {data.PageHeading && (
                <h1 className="mb-4 text-4xl font-semibold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl ">
                  {data.PageHeading}
                </h1>
              )}
              {data.PageParagraph && (
                <p className="mb-8 text-md font-normal lg:text-xl sm:px-16 xl:px-48">
                  {data.PageParagraph}
                </p>
              )}
            </div>
          </Container>
        </Section>
      )}
    </>
  );
}

export default InnerBannerSection;
